export default "__VITE_ASSET__ZPfbe_iZ__"